import { ACTION } from './constants';
import request from '../../../../utils/request';
import { requestConfig } from '../../../../config/apiResource';
import {showMainLoader, hideMainLoader} from '../../../actions';


export function verifyPanFolio(params) {
    return dispatch => {
        dispatch(showMainLoader());
        return request(requestConfig.verifyPanFolio(params))
            .then((json) => {
                dispatch(hideMainLoader());
                json && dispatch({ type: ACTION.VERIFY_PAN_FOLIO, data: json });
              
                return json;
            }).catch((error) => {
                dispatch(hideMainLoader());
                console.log("Got Error with verify pan folio data: " + error)
            });
    }
}

export function clearverifyPanFolio() {
    return dispatch => {
        dispatch({ type: ACTION.VERIFY_PAN_FOLIO, data: { apiLoaded: false} });
    }
}

export function verifyAccountStatementOtp(params) {
    return dispatch => {
        dispatch(showMainLoader());
        return request(requestConfig.verifyAccountStatementOtp(params))
            .then((json) => {
                dispatch(hideMainLoader());
                json && dispatch({ type: ACTION.VERIFY_OTP, data: json });
           
                return json;
            }).catch((error) => {
                dispatch(hideMainLoader());
                console.log("Got Error with verify pan folio data: " + error)
            });
    }
}

export function clearVerifyAccountStatementOtp() {
    return dispatch => {
        dispatch({ type: ACTION.VERIFY_OTP, data: { apiLoaded: false} });
    }
}

export function getTokenFromUuid(params) {
    return dispatch => {
        dispatch(showMainLoader());
        return request(requestConfig.getTokenFromUuid(params))
            .then((json) => {
                dispatch(hideMainLoader());
                json && dispatch({ type: ACTION.TOKEN, data: json });
           
                return json;
            }).catch((error) => {
                dispatch(hideMainLoader());
                console.log("Got Error with verify pan folio data: " + error)
            });
    }
}

export function getAccountStatement(params, token) {
    return dispatch => {
        dispatch(showMainLoader());
        return request(requestConfig.getAccountStatementJava(params, token))
            .then((json) => {
                dispatch(hideMainLoader());
                if(json instanceof ArrayBuffer){
                    const blob = new Blob([json], { type: "application/pdf" });
                    const fileUrl = URL.createObjectURL(blob);
                    const a = document.createElement("a");
                    a.href = fileUrl;
                    a.download = "Account_Statement.pdf"; // Set file name
                    document.body.appendChild(a);
                    a.click();
                    document.body.removeChild(a);
                }
                else{
                    json && dispatch({ type: ACTION.ACCOUNT_STATEMENT, data: json });
                    return json;
                }
            }).catch((error) => {
                dispatch(hideMainLoader());
                console.log("Got Error with verify pan folio data: " + error)
            });
    }
}
export function allSectionsMeta(type) {
    let typeData;
    if(!__CLIENT__){
        typeData = 'account-statement';
    }else{
        typeData = type;
    }

    return dispatch => {
        return request(requestConfig.allSectionsMeta(typeData))
            .then((json) => {
                json && dispatch({ type: ACTION.ACCOUNT_META, data: json });
                return json;
            }).catch((error) => {
                console.log("Got Error with verify pan folio data: " + error)
            });
    }
}